import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { PlayArrow } from '@mui/icons-material';
import { OffenderField } from '../../../../../components/risk-assessments/offender-card-parts';

export interface ConfirmSearchField {
    label: string;
    value: string;
    fullWidth?: boolean;
}

interface Props {
    open: boolean;
    fields: ConfirmSearchField[];
    onConfirm(): void;
    onCancel(): void;
}

// Review step before a search runs: each assessment is billed per call and
// runs against the details exactly as typed, so a mistyped name silently
// produces a wrong (and paid-for) report. Field styling mirrors the report's
// offender tiles (label-over-value grid) so the flow reads as one product.
export const ConfirmSearchDialog: React.FC<Props> = ({ open, fields, onConfirm, onCancel }) => (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
        <DialogTitle fontWeight={500} textAlign={'left'}>
            Review Assessment Details
        </DialogTitle>
        <DialogContent sx={{ mt: 1 }}>
            <DialogContentText textAlign={'left'} sx={{ mb: 2 }}>
                The assessment runs against these details exactly as entered. Check the spelling before running.
            </DialogContentText>
            <Box
                sx={{
                    bgcolor: '#F9FAFB',
                    border: '1px solid #DFE3E8',
                    borderRadius: 1,
                    p: 2,
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    gap: 1.5,
                }}
            >
                {fields.map((field) => (
                    <OffenderField
                        key={field.label}
                        label={field.label}
                        value={field.value}
                        sx={field.fullWidth ? { gridColumn: '1 / -1' } : undefined}
                    />
                ))}
            </Box>
        </DialogContent>
        <Box sx={{ borderTop: 1, m: 1, p: 1, gap: 2, display: 'flex', borderColor: 'divider', flexDirection: 'row-reverse' }}>
            <Button variant="alternate" onClick={onConfirm} startIcon={<PlayArrow />}>
                Run Assessment
            </Button>
            <Button variant="outlined-alternate" onClick={onCancel}>
                Go Back & Edit
            </Button>
        </Box>
    </Dialog>
);
